import Axios from 'api/client';
import {
    GivebutterPlusPlan,
    SubscriptionBillingPeriod,
    SubscriptionProductType,
    SubscriptionTier,
} from 'types/domain';

interface CreateSubscriptionParams {
    product: SubscriptionProductType;
    tier: SubscriptionTier;
    billing_period: SubscriptionBillingPeriod;
}

interface UpdateSubscriptionParams {
    tier: SubscriptionTier;
    billing_period: SubscriptionBillingPeriod;
}

interface CreateSubscriptionResponse {
    client_secret: string;
    session_id: string;
}

interface CreateSubscriptionCallbackParams {
    session_id: string;
}

interface FetchBillingPlansResponse {
    current_contact_count: number;
    plans: GivebutterPlusPlan[];
}

interface StartGivebutterPlusFreeTrialParams {
    yearly_donation_volume: string;
    estimated_contacts: string;
}

interface EndGivebutterPlusFreeTrialParams {
    reason: string;
    reason_other?: string;
}

const createSubscriptionStripeSession = (accountId: number, params: CreateSubscriptionParams) =>
    Axios.post<CreateSubscriptionResponse>(`accounts/${accountId}/billing/subscribe`, params).then(
        response => response.data,
    );

const createSubscriptionCallback = (accountId: number, params: CreateSubscriptionCallbackParams) =>
    Axios.post(`accounts/${accountId}/billing/subscribe/callback`, params).then(
        response => response.data,
    );

const fetchBillingPlans = (accountId: number) =>
    Axios.get<FetchBillingPlansResponse>(`accounts/${accountId}/billing/plans`).then(
        response => response.data,
    );

const startGivebutterPlusFreeTrial = (
    accountId: number,
    params: StartGivebutterPlusFreeTrialParams,
) =>
    Axios.post(`accounts/${accountId}/billing/plans/plus/start-trial`, params).then(
        response => response.data,
    );

const endGivebutterPlusFreeTrial = (accountId: number, params: EndGivebutterPlusFreeTrialParams) =>
    Axios.post(`accounts/${accountId}/billing/plans/plus/end-trial`, params).then(
        response => response.data,
    );

const updateAccountBillingSubscription = (accountId: number, params: UpdateSubscriptionParams) =>
    Axios.patch(`accounts/${accountId}/billing/subscription`, params).then(
        response => response.data,
    );

export {
    createSubscriptionStripeSession,
    createSubscriptionCallback,
    fetchBillingPlans,
    startGivebutterPlusFreeTrial,
    endGivebutterPlusFreeTrial,
    updateAccountBillingSubscription,
};

export type {
    CreateSubscriptionParams,
    CreateSubscriptionResponse,
    CreateSubscriptionCallbackParams,
};
